import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useRoleCookie from "shared/model/useRoleCookie"
import { ROLE_COMPETITION_MANAGER, ROLE_FIELD_MANAGER, ROLE_FRANCHISE_MANAGER, ROLE_STORE_MANAGER, ROLE_TIMER_MANAGER } from "shared/constant/lookup/role"

const useGetManagerEvent = () => {
    const [roleCookie] = useRoleCookie()
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        if ([ROLE_FRANCHISE_MANAGER, ROLE_STORE_MANAGER, ROLE_FIELD_MANAGER, ROLE_TIMER_MANAGER, ROLE_COMPETITION_MANAGER].includes(roleCookie)) {
            fetchRequest("GET", `/admin/event/my/list/active`)
        }
    }, [])

    return [fetchResult]
}

export default useGetManagerEvent